/**
 * S_ServerMessage(opcode 14) 번호 → 표시 문장 — **자동 생성 파일. 직접 고치지 말 것.**
 *
 * 서버는 이 패킷에 **문장을 담지 않는다.** 메시지 번호와 인자만 보내고, 원본
 * 클라이언트가 자기 리소스에서 문장을 찾아 `%0`, `%1` 자리에 인자를 끼워 넣는다.
 * 웹 클라이언트에는 그 리소스가 없으므로 여기에 직접 적어 둔다.
 *
 * 문장은 L1J 서버 소스에서 `new S_ServerMessage(<번호>)` 호출부에 달린 일본어
 * 주석을 옮긴 것이다 — 주석이 유일한 근거라, 주석이 없거나 문장이 아닌 번호는
 * 넣지 않았다. 표에 없는 번호는 `formatServerMessage()`가 인자만이라도 보여주므로
 * 화면이 비지 않는다.
 *
 * 재생성: python3 scripts/gen_server_messages.py > web-client/src/data/serverMessages.ts
 */
export const SERVER_MESSAGES: Record<number, string> = {
  64: '월드와의 접속이 끊어졌습니다.', // ワールドとの接続が切断されました。
  73: '%0 님은 게임을 하고 있지 않습니다.', // %0はゲームをしていません。
  74: '%0 은(는) 사용할 수 없습니다.', // %0は使用できません。
  75: '더 이상 물건을 놓을 자리가 없습니다.', // これ以上ものを置く場所がありません。
  76: '%0 을(를) 먹었습니다.', // %0を食べました。
  77: '기분이 좋아졌습니다.', // 気分が良くなりました。
  79: '아무 일도 일어나지 않았습니다.', // 何も起きませんでした。
  82: '아이템이 너무 무거워 더 들 수 없습니다.', // アイテムが重すぎて、これ以上持てません。
  84: '%0 혈맹이 창설되었습니다.', // %0血盟が創設されました。
  85: '프린스와 프린세스만 혈맹을 창설할 수 있습니다.', // プリンスとプリンセスだけが血盟を創設できます。
  86: '이미 혈맹을 결성했으므로 만들 수 없습니다.', // すでに血盟を結成されているので作成できません。
  89: '이미 혈맹에 가입되어 있습니다.', // あなたはすでに血盟に加入しています。
  90: '%0 님은 혈맹을 창설하지 않은 상태입니다.', // %0は血盟を創設していない状態です。
  91: '%0 님이 당신을 보고 있지 않습니다.', // %0があなたを見ていません。
  92: '%0 님은 프린스나 프린세스가 아닙니다.', // %0はプリンスやプリンセスではありません。
  93: '그곳에는 아무도 없습니다.', // そこには誰もいません。
  94: '%0 님이 혈맹의 일원으로 받아들여졌습니다.', // %0が血盟の一員として受け入れられました。
  95: '%0 혈맹에 가입했습니다.', // %0血盟に加入しました。
  96: '%0 님이 당신의 요청을 거절했습니다.', // %0はあなたの要請を拒絶しました。
  99: '같은 이름의 혈맹이 이미 있습니다.', // 同じ名前の血盟が存在します。
  109: '%0 라는 이름의 사람이 없습니다.', // %0という名前の人はいません。
  110: '아이템이 너무 무거워 전투할 수 없습니다.', // アイテムが重すぎて戦闘することができません。
  117: '%0 님이 당신을 차단했습니다.', // %0があなたを遮断しました。
  124: '이미 무언가를 착용하고 있습니다.', // すでに何かを装備しています。
  125: '삭제할 수 없는 아이템이나 착용 중인 아이템은 버릴 수 없습니다.', // 削除できないアイテムや装備しているアイテムは捨てられません。
  126: '%1 위에 %0 을(를) 착용할 수 없습니다.', // %1上に%0を着ることはできません。
  127: '그것은 벗을 수 없습니다.', // それは脱ぐことができません
  128: '방패를 착용한 상태에서는 양손 무기를 쓸 수 없습니다.', // シールドを装備している時は両手で持つ武器を使うことはできません。
  129: '양손 무기를 든 채로는 방패를 착용할 수 없습니다.', // 両手の武器を武装したままシールドを着用することはできません。
  141: '착용 중인 물건은 남에게 건넬 수 없습니다.', // 装備しているものは、人に渡すことができません。
  143: '%0 이(가) %1 을(를) 주었습니다.', // %0が%1をくれました。
  149: '%0 이(가) 손에 달라붙었습니다.', // %0が手にくっつきました。
  150: '벗을 수 없습니다. 저주가 걸린 것 같습니다.', // はずすことができません。呪いをかけられているようです。
  153: '도배 채팅을 했으므로 앞으로 2분간 채팅할 수 없습니다.', // 迷惑なチャット流しをしたので、今後2分間チャットを行うことはできません。
  154: '스크롤이 흩어집니다.', // スクロールが散らばります。
  155: '누군가 도와준 것 같습니다.', // 誰かが助けてくれたようです。
  158: '%0 이(가) 증발하여 사라졌습니다.', // %0が蒸発してなくなりました。
  160: '%0 이(가) %2 과(와) 강렬하게 %1 빛났지만 다행히 무사했습니다.', // %0が%2と強烈に%1光りましたが、幸い無事にすみました。
  161: '%0 이(가) %2 %1 빛납니다.', // %0が%2%1光ります。
  167: '피부가 근질거립니다.', // 肌がムズムズします。
  178: '%0 님이 %1 혈맹에서 탈퇴했습니다.', // %0が%1血盟を脱退しました。
  181: '그런 몬스터로는 변신할 수 없습니다.', // そのようなモンスターには変身できません。
  183: '몸에 새로운 힘이 넘칩니다.', // 体に新たな力がみなぎります。
  188: '%0 님은 당신을 혈맹원으로 받아들일 수 없습니다.', // %0はあなたを血盟員として受け入れることができません。
  189: '아데나가 부족합니다.', // アデナが不足しています。
  195: '레벨 %0 미만인 캐릭터는 채팅할 수 없습니다.', // レベル%0未満のキャラクターはチャットができません。
  196: '다음과 같이 입력해 주세요: 「/title 캐릭터명 칭호」', // 次のように入力してください：「/title \f0キャラクター名 呼称\f1」
  197: '혈맹원은 레벨 10 이상이어야 칭호를 가질 수 있습니다.', // 血盟員の場合、呼称を持つにはレベル10以上でなければなりません。
  198: '혈맹원에게 칭호를 줄 수 있는 사람은 프린스와 프린세스뿐입니다.', // 血盟員に呼称を与えられるのはプリンスとプリンセスだけです。
  199: '혈맹원이 아니면 남에게 칭호를 줄 수 없습니다.', // 血盟員でなければ他人に呼称を与えることはできません。
  200: '혈맹원이 아닌 상태로 칭호를 가지려면 레벨 40 이상이어야 합니다.', // 血盟員ではないのに呼称を持つには、レベル40以上でなければなりません。
  201: '%0 님은 당신의 혈맹이 아닙니다.', // %0はあなたの血盟ではありません。
  202: '%0 님의 레벨이 10 미만이라 칭호를 줄 수 없습니다.', // %0のレベルが10未満なので呼称を与えることはできません。
  203: '%0 님이 %1 님에게 「%2」 칭호를 주었습니다.', // %0が%1に「%2」という呼称を与えました。
  208: '혈맹 창고를 쓰려면 혈맹에 가입해야 합니다.', // 血盟倉庫を使用するには血盟に加入していなくてはなりません。
  209: '다른 혈맹원이 창고를 쓰는 중입니다. 잠시 후 이용해 주세요.', // 他の血盟員が倉庫を使用中です。しばらく経ってから利用してください。
  210: '%0 은(는) 버리거나 남에게 넘길 수 없습니다.', // %0は捨てたりまたは他人に讓ることができません。
  214: '이곳을 기억할 수 없습니다.', // ここを記憶することができません。
  218: '%0 혈맹의 군주가 지금 월드에 없습니다.', // %0血盟の君主は現在ワールドに居ません。
  230: '랜턴에 기름을 부었습니다.', // ランタンにオイルを注ぎました。
  232: '레벨 15 이하의 군주는 선전포고할 수 없습니다.', // レベル15以下の君主は宣戦布告できません。
  234: '당신의 혈맹은 이미 전쟁 중입니다.', // あなたの血盟はすでに戦争中です。
  236: '%0 혈맹이 당신 혈맹과의 전쟁을 거절했습니다.', // %0血盟があなたの血盟との戦争を拒絶しました。
  237: '%0 혈맹이 당신의 제안을 거절했습니다.', // %0血盟があなたの提案を拒絶しました。
  238: '당신은 %0 혈맹에서 추방되었습니다.', // あなたは%0血盟から追放されました。
  240: '%0 님이 당신의 혈맹에서 추방되었습니다.', // %0があなたの血盟から追放されました。
  241: '%0 님이 당신을 변신시켰습니다.', // %0があなたを変身させました。
  242: '지금은 채팅 금지 상태입니다.', // 現在チャット禁止中です。
  253: '%0 님이 당신과의 거래에 응하지 않았습니다.', // %0%dはあなたとの取引に応じませんでした。
  263: '한 캐릭터가 가지고 다닐 수 있는 아이템은 최대 180개입니다.', // 一人のキャラクターが持って歩けるアイテムは最大180個までです。
  264: '당신의 클래스로는 이 아이템을 쓸 수 없습니다.', // あなたのクラスではこのアイテムは使用できません。
  269: '%1 혈맹의 혈맹주 %0 님이 혈맹을 해산했습니다.', // %1血盟の血盟主%0が血盟を解散させました。
  270: '가진 물건이 무거워 거래할 수 없습니다.', // 持っているものが重くて取引できません。
  271: '상대가 물건을 너무 많이 들고 있어 거래할 수 없습니다.', // 相手が物を持ちすぎていて取引できません。
  272: '전쟁을 하려면 먼저 혈맹을 창설해야 합니다.', // 戦争するためにはまず血盟を創設しなければなりません。
  278: 'MP가 부족해 마법을 쓸 수 없습니다.', // MPが不足していて魔法を使うことができません。
  279: 'HP가 부족해 마법을 쓸 수 없습니다.', // HPが不足していて魔法を使うことができません。
  280: '마법이 실패했습니다.', // 魔法が失敗しました。
  281: '마법이 무효가 되었습니다.', // 魔法が無効になりました。
  285: '그 상태에서는 마법을 쓸 수 없습니다.', // その状態では魔法を使えません。
  286: '게임에 어울리지 않는 행동이므로 앞으로 %0분간 채팅을 금지합니다.', // ゲームに適合しない行動であるため、今後%0分間チャットを禁じます。
  287: '%0 님의 채팅을 금지했습니다.', // %0のチャットを禁じました。
  288: '다시 채팅할 수 있게 되었습니다.', // チャットができるようになりました。
  297: '가벼운 현기증을 느꼈습니다.', // 軽いめまいを覚えました。
  299: '마법을 외울 재료가 부족합니다.', // 詠唱する材料がありません。
  302: '해산시킬 수 없습니다.', // 解散させることができません。
  309: '%0 의 정산 총액은 %1 아데나입니다.', // %0の精算総額は%1アデナです。
  312: '레벨이 낮아 그 마법을 배울 수 없습니다.', // レベルが低くてその魔法を覚えることができません。
  318: '이 아이템은 %0 레벨 이상이어야 사용할 수 있습니다.', // このアイテムは%0レベル以上にならなければ使用できません。
  319: '더 이상 몬스터를 부릴 수 없습니다.', // これ以上のモンスターを操ることはできません。
  320: '%0 의 레벨이 올랐습니다.', // %0のレベルが上がりました。
  324: '길들이기에 실패했습니다.', // てなずけるのに失敗しました。
  326: '한 번 정한 이름은 바꿀 수 없습니다.', // 一度決めた名前は変更できません。
  327: '같은 이름이 이미 있습니다.', // 同じ名前がすでに存在しています。
  328: '올바른 대상을 선택해 주세요.', // 正しい対象を選択してください。
  329: '%0 을(를) 가지고 있지 않습니다.', // %0を持っていません。
  337: '%0 이(가) 부족합니다.', // %0が不足しています。
  338: '당신의 %0 이(가) 회복되고 있습니다.', // あなたの%0が回復していきます。
  352: '이 마법을 쓰려면 성향치가 %0 이어야 합니다.', // この魔法を利用するには性向値が%0でなければなりません。
  403: '%0 을(를) 얻었습니다.', // %0を手に入れました。
  404: '%0 레벨 이하에서는 귓속말과 파티 채팅을 쓸 수 없습니다.', // %0レベル以下ではウィスパー、パーティーチャットは使用できません。
  414: '같은 혈맹원이 아닙니다.', // 同じ血盟員ではありません。
  415: '이미 다른 파티에 속해 있어 초대할 수 없습니다.', // すでに他のパーティーに所属しているため招待できません
  416: '파티 리더만 초대할 수 있습니다.', // パーティーのリーダーのみが招待できます。
  417: '더 이상 파티원을 받을 수 없습니다.', // これ以上パーティーメンバーを受け入れることはできません。
  418: '파티를 해산했습니다.', // パーティーを解散しました。
  419: '파티에서 추방되었습니다.', // パーティーから追放されました。
  420: '%0 님이 파티에서 나갔습니다.', // %0がパーティーから去りました。
  423: '%0 님이 초대를 거절했습니다.', // %0が招待を拒否しました。
  424: '%0 님이 파티에 들어왔습니다.', // %0がパーティーに入りました。
  425: '파티에 가입되어 있지 않습니다.', // パーティーに加入していません。
  426: '%0 님은 파티원이 아닙니다.', // %0はパーティーメンバーではありません。
  427: '파티 리더만 추방할 수 있습니다.', // パーティーのリーダーのみが追放できます。
  452: '%0 이(가) 선택되었습니다.', // %0が選択されました。
  462: '배가 고파 채팅할 수 없습니다.', // 空腹のためチャットできません。
  463: '%0 의 상태가 좋아졌습니다.', // %0の状態が良くなりました。
  464: '%0 이(가) 새것과 같은 상태가 되었습니다.', // %0%sは新品同様の状態になりました。
  472: '차단한 사용자가 너무 많습니다.', // 遮断されたユーザーが多すぎます。
  474: '이미 성을 소유하고 있어 다른 성을 차지할 수 없습니다.', // あなたはすでに城を所有しているので、他の城を取ることは出来ません。
  475: '공성전을 선언하려면 레벨 25에 도달해야 합니다.', // 攻城戦を宣言するにはレベル25に達していなければなりません。
  476: '아직 공성전 시간이 아닙니다.', // まだ攻城戦の時間ではありません。
  477: '당신을 포함한 모든 혈맹원이 성 밖으로 나가야 공성전을 선언할 수 있습니다.', // あなたを含む全ての血盟員が城の外に出なければ攻城戦は宣言できません。
  478: '프린스와 프린세스만 전쟁을 선포할 수 있습니다.', // プリンスとプリンセスのみ戦争を布告できます。
  481: '한 능력치의 최대값은 35입니다. 다른 능력치를 선택해 주세요.', // 一つの能力値の最大値は35です。他の能力値を選択してください。
  489: '데려가려는 펫이 너무 많습니다.', // 引き取ろうとするペットが多すぎます。
  510: '현재 월드 채팅이 중지되어 있습니다. 잠시 양해해 주세요.', // 現在ワールドチャットは停止中となっております。しばらくの間ご了承くださいませ。
  513: '집 이름이 너무 깁니다.', // 家の名前が長すぎます。
  518: '이 명령은 혈맹 군주만 쓸 수 있습니다.', // この命令は血盟の君主のみが利用できます。
  519: '레벨 15 미만의 군주는 경매에 참가할 수 없습니다.', // レベル15未満の君主は競売に参加できません
  521: '이미 집을 소유하고 있습니다.', // すでに家を所有しています
  523: '이미 다른 집의 경매에 참가하고 있습니다.', // すでに他の家の競売に参加しています。
  524: '축하합니다. 참가하신 경매가 최종 가격 %0 아데나에 낙찰되었습니다. %1 님이 구매하신 집은 바로 이용하실 수 있습니다.', // おめでとうございます。あなたが参加された競売は最終価格%0アデナの価格で落札されました。%1様がご購入された家はすぐにご利用できます。
  525: '제시하신 금액보다 높은 금액을 제시한 분이 나타나 아쉽게도 입찰에 실패했습니다. 경매에 맡기신 %0 아데나를 돌려드립니다.', // あなたが提示された金額よりももっと高い金額を提示した方が現れたため、残念ながら入札に失敗しました。あなたが競売に預けた%0アデナをお返しします。
  527: '소유하고 계시던 집이 최종 가격 %1 아데나에 낙찰되었습니다. 수수료 10%를 제외한 %0 아데나를 드립니다.', // あなたが所有していた家が最終価格%1アデナで落札されました。手数料10%を除いた残りの金額%0アデナを差し上げます。
  528: '신청하신 경매는 기간 내에 제시 금액 이상을 내겠다는 분이 나타나지 않아 취소되었습니다. 소유권은 당신에게 돌아갑니다.', // あなたが申請なさった競売は、競売期間内に提示した金額以上での支払いを表明した方が現れなかったため、結局取り消されました。従って、所有権があなたに戻されたことをお知らせします。
  546: '당신의 파트너는 지금 게임을 하고 있지 않습니다.', // あなたのパートナーは今プレイをしていません。
  547: '당신의 파트너는 지금 갈 수 없는 곳에서 플레이 중입니다.', // あなたのパートナーは今あなたが行けない所でプレイ中です。
  548: '당신의 파트너는 지금 게임 중입니다.', // あなたのパートナーは今ゲーム中です。
  549: '당신의 파트너가 방금 접속했습니다.', // あなたのパートナーはたった今ログインしました。
  559: '아직 죄를 씻을 만큼 선행을 쌓지 못했습니다.', // まだ罪晴らしに十分な善行を行っていません。
  560: '아직 죄를 씻을 필요가 없습니다.', // まだ罪晴らしをする必要はありません。
  561: 'PK 횟수가 %0 이(가) 되었습니다.', // PK回数が%0になりました。
  562: '현재 PK 횟수는 %0 입니다.', // 現在のPK回数は%0です。
  563: '여기에서는 쓸 수 없습니다.', // ここでは使えません。
  591: '스크롤이 그렇게 강한 마법을 기록하기에는 너무 약합니다.', // スクロールがそんな強い魔法を記録するにはあまりに弱いです。
  592: '그 자리에 다른 사람이 서 있어 부활시킬 수 없습니다.', // その場所に他の人が立っているので復活させることができません。
  623: '아이템을 주울 수 없었습니다.', // アイテムが拾えませんでした。
  627: '장애물이 있어 그곳까지 이동할 수 없습니다.', // 障害物があってそこまで移動することができません。
  631: '%0 님이 당신과의 결투를 거절했습니다.', // %0%dがあなたとの決闘を断りました。
  633: '당신은 이미 다른 사람과 결투 중입니다.', // あなたはすでにほかの人と決闘中です。
  634: '이미 다른 사람과 결투 중입니다.', // すでにほかの人と決闘中です。
  638: '%0 을(를) 잃었습니다.', // %0を失いました
  643: '성을 점령했습니다.', // 城を占拠しました。
  647: '주변 에너지가 텔레포트를 방해하고 있습니다. 이곳에서는 텔레포트를 쓸 수 없습니다.', // 周辺のエネルギーがテレポートを妨害しています。そのため、ここでテレポートは使用できません。
  657: '당신은 이미 결혼했습니다.', // あなたはすでに結婚しています。
  658: '그 상대는 이미 결혼했습니다.', // その相手はすでに結婚しています。
  661: '결혼 상대는 이성이어야 합니다.', // 結婚相手は異性でなければなりません。
  662: '당신은 결혼하지 않았습니다.', // あなたは結婚していません。
  665: '성이나 아지트를 소유한 상태로는 혈맹을 해산할 수 없습니다.', // 城やアジトを所有した状態で血盟を解散することはできません。
  693: '당신의 무기에 축복이 깃듭니다.', // あなたの武器に祝福が宿ります。
  698: '마력 때문에 아무것도 마실 수 없습니다.', // 魔力によって何も飲むことができません。
  728: '일반 혈맹원은 혈맹 창고를 이용할 수 없습니다.', // 一般の血盟員は、血盟倉庫を利用することはできません。
  739: '지금은 경험치를 회복할 수 없습니다.', // 今は経験値を回復することができません。
  743: '레벨이 낮아 해당 몬스터를 소환할 수 없습니다.', // レベルが低くて該当のモンスターを召還することができません。
  756: '당신은 다른 마을의 주민입니다.', // あなたは他の村の住民です。
  757: '주민 등록은 레벨 10 이상인 캐릭터만 할 수 있습니다.', // 住民登録ができるのはレベル10以上のキャラクターです。
  758: '현재 주민 등록된 곳은 %0 입니다.', // 現在、あなたが住民登録している場所は%0です。
  759: '새로 주민 등록을 하려면 시간이 걸립니다. 시간이 지난 뒤 다시 등록해 주세요.', // 新しく住民登録を行なうには時間がかかります。時間を置いてからまた登録してください。
  766: '이미 보상을 받았거나 공헌도가 부족해 보상을 받을 수 없습니다. 다음 달에 다시 와 주세요.', // すでに報酬をもらっているか、貢献度不足で報酬を受けることができません。また来月お越しください。
  767: '마을 지원금이 없습니다. 다음 달에 다시 와 주세요.', // 村の支援金がありません。また来月お越しください。
  820: '몸의 힘이 변해 가는 것을 느낍니다.', // 体の力が変化していくのを感じます。
  822: '몸 깊은 곳에서 신비한 힘이 솟는 것을 느낍니다.', // 体の奥深くから不思議な力が湧き起こるのを感じます。
  830: '몸에서 느끼던 힘이 사라져 갑니다.', // 体に感じた力が消えていきます。
  843: '지금 혈맹원 %0 님이 게임에 접속했습니다.', // 只今、血盟員の%0%sがゲームに接続しました。
  876: '이곳에서는 개인 상점을 열 수 없습니다.', // この場所では個人商店を開けません。
  877: '%1 을(를) %0 님에게 판매했습니다.', // %1を%0に販売しました。
  904: '총 판매 가격은 정해진 아데나를 넘을 수 없습니다.', // 総販売価格は%dアデナを超過できません。
  905: '착용 중인 아이템은 판매할 수 없습니다.', // 装備しているアイテムは販売できません。
  942: '상대의 아이템이 너무 무거워 더 줄 수 없습니다.', // 相手のアイテムが重すぎるため、これ以上あげられません。
  966: '마법의 힘으로 보호받습니다.', // 魔法の力によって保護されます。
  990: '성문 자동 수리를 명령했습니다.', // 城門自動修理を命令しました。
  991: '성문 자동 수리 명령을 취소했습니다.', // 城門自動修理命令を取り消しました。
  1007: 'MP 회복 속도가 빨라집니다.', // MPの回復速度が速まります。
  1008: '그 상태에서는 주문을 욀 수 없습니다.', // その状態では詠唱できません。
  1052: '%0 님은 이미 등록되어 있습니다.', // %0は既に登録されています。
  1064: '혈맹에 속해 있지 않습니다.', // 血盟に属していません。
  1078: '발로그의 웃음소리가 머릿속을 때립니다.', // バルログの笑い声が脳裏を強打します。
  1079: '야히의 모습이 점점 가깝게 느껴집니다.', // ヤヒの姿がだんだん近くに感じられます。
  1080: '발로그의 비웃음이 느껴져 오한이 스칩니다.', // バルログの冷笑を感じ悪寒が走ります。
  1081: '야히의 모습을 기억하기 어려워집니다.', // ヤヒの姿を記憶するのが難しくなります。
  1098: '지하 아지트가 없어 텔레포트할 수 없습니다.', // 地下アジトがないため、テレポートできません。
  1099: '지하 아지트가 생성되었습니다.', // 地下アジトが生成されました。
  1101: '요리에 실패했습니다.', // 料理が失敗しました。
  1102: '요리 재료가 부족합니다.', // 料理の材料が足りません。
  1103: '아이템이 너무 무거워 요리할 수 없습니다.', // アイテムが重すぎて、料理できません。
  1135: '이미 지하 아지트를 소유하고 있습니다.', // 既に地下アジトを所有しています。
  1136: '낚시에 실패했습니다.', // 釣りに失敗しました。
  1137: '낚시를 하려면 미끼가 필요합니다.', // 釣りをするためにはエサが必要です。
  1138: '이곳에는 낚싯대를 던질 수 없습니다.', // ここに釣り竿を投げることはできません。
  1160: '요리에는 모닥불이 필요합니다.', // 料理には焚き火が必要です。
  1161: '녹일 수 없습니다.', // 溶解できません。
  1166: '%0 님이 펫 매치에서 승리했습니다.', // %0%sペットマッチで勝利を収めました。
  1170: '이곳에서는 변신할 수 없습니다.', // ここでは変身できません。
  1181: '해당 매직돌은 현재 사용 중입니다.', // 該当のマジックドールは現在使用中です。
  1182: '게임은 이미 시작됐어.', // もうゲームは始まってるよ。
  1184: '유령의 집은 사람으로 가득 찼어.', // お化け屋敷は人でいっぱいだよ。
  1187: '펫 아뮬렛을 사용 중입니다.', // ペットのアミュレットが使用中です。
  1253: '엔트리 번호 %0 번으로 출전이 예약되었습니다.', // エントリーナンバー%0での出場が予約されました。
  1254: '이미 출전 예약이 접수되었습니다.', // 既に出場予約が受け付けられています。
  1255: '출전 예약이 취소되었습니다.', // 出場予約がキャンセルされました。
  1257: '곧 레이스가 시작됩니다.', // まもなくレースがスタートします。
  1259: '곧 마을로 이동됩니다.', // まもなく村へ移動されます。
  1265: '엔트리 번호 %0 번으로 데스매치 출전이 예약되었습니다.', // エントリーナンバー%0でデスマッチへの出場が予約されました。
  1266: '이미 데스매치 출전 예약이 접수되었습니다.', // すでにデスマッチへの出場予約が受け付けられています。
  1269: '곧 데스매치가 시작됩니다.', // まもなくデスマッチがスタートします。
  1271: '전투에서 패배해 관전자가 되었습니다.', // 戦闘に敗れたため観戦者となりました。
  1272: '데스매치에서 승리했습니다.', // デスマッチで勝利を収めました。
  1273: '고른 매치는 Lv%0 ~ Lv%1 이(가) 참가할 수 있습니다.', // 選んだマッチはLv%0〜Lv%1が参加できます。
  1274: '생존자는 %0 명 남았습니다.', // 生存者は残り%0名です。
  1275: '데스매치 종료 시간입니다. 우승자가 없어 게임을 종료합니다.', // デスマッチ終了の時間となりました。優勝者はいませんでした。ゲームを終了します。
  1287: '지금 레벨로는 들어갈 수 없습니다.', // 今のレベルでは入れません。
  1290: '스탯 초기화에 필요한 아이템이 없습니다.', // ステータス初期化に必要なアイテムがありません。
  1308: '%0 이(가) 마력의 힘으로 증발에서 보호됩니다.', // %0が魔力の力で蒸発から守られます。
  1309: '이 장비에는 증발 보호 스크롤을 쓸 수 없습니다.', // この装備には蒸発保護スクロールが使えません。
  1310: '강렬한 빛을 냈지만 장비가 증발하지 않았습니다.', // 強烈な光りを放ちましたが、装備が蒸発しませんでした。
  1387: '오늘은 더 이상 데스매치를 이용할 수 없습니다.', // 今日はもうデスマッチの利用ができません。
  1390: '데스매치 입장 예약이 4회 취소되어 마지막 1회가 남았습니다.', // デスマッチの入場の予約が4回キャンセルされ、最後の1回残っています。
  1410: '%0 에 강력한 마법의 힘이 스며듭니다.', // %0に強力な魔法の力が染み入ります。
  1411: '%0 에 마법이 스며들지 않습니다.', // %0に魔法が入り込めません。
  1412: '이미 바닥에 큐브가 소환되어 있습니다.', // すでに床にキューブが召喚されています。
  1453: '더 이상 강화할 수 없습니다.', // これ以上は強化できません。
  1522: '던전 체류 기한 %0 시간이 지났습니다.', // ダンジョン滞在期限%0時間を過ぎました。
  1523: '던전 체류 기한 %0 분이 지났습니다.', // ダンジョン滞在期限%0分を過ぎました。
  1524: '던전 체류 기한 %0 시간 %1 분이 지났습니다.', // ダンジョン滞在期限%0時間%1分を過ぎました。
  1525: '던전 체류 기한이 %0 시간 %1 분 남았습니다.', // ダンジョン滞在期限の残りは%0時間%1分です。
  1526: '던전 체류 기한이 %0 시간 남았습니다.', // ダンジョン滞在期限の残りは%0時間です。
  1527: '던전 체류 기한이 %0 분 남았습니다.', // ダンジョン滞在期限の残りは%0分です。
  1528: '던전 체류 기한이 %0 초 남았습니다.', // ダンジョン滞在期限の残りは%0秒です。
  1536: '정원이 차서 입장할 수 없습니다.', // 定員に達したため、入場できません。
  1537: '드래곤이 깨어나 지금은 입장할 수 없습니다.', // ドラゴンが目覚めたため、今は入場できません。
  1566: '드래곤 키가 필요합니다.', // ドラゴンキーが必要です。
  1580: '안타라스: 너희에게는 황혼의 저주가 있으리라! 쉬렌이여! 어머니여! 구원하소서…', // アンタラス：おまえらは黄昏の呪いがあるだろう！シーレンよ！母上よ！お救いください…
  1626: '온몸에서 드래곤의 피 냄새가 납니다. 냄새가 사라질 때까지는 드래곤 포탈에 들어갈 수 없습니다.', // 全身からドラゴンの血の匂いが漂っています。それが消えるまでは、ドラゴンポータルに入場できません。
  1643: '화요일 오전 7시부터 10시까지는 드래곤 키를 쓸 수 없습니다.', // 火曜日午前7時から10時まではドラゴンキーを使用できません。
  1668: '파푸리온: 사엘 이놈… 쉬렌이여! 어머니여! 구원하소서…', // パプリオン：サエルめ…シーレンよ！母上よ！お救いください…
  1696: '현재 파티에 속한 멤버가 아닙니다.', // 現在、パーティーに所属しているメンバーではありません。
  1697: '파티 리더가 아니라 권한을 행사할 수 없습니다.', // パーティーリーダーではないため、権限を行使できません。
  1739: '빛나는 비늘을 낚아 마법의 낚시가 끝났습니다.', // 輝く鱗を釣り上げたため、魔法の釣りが終了しました。
  1773: '린드비오르: 아앗! 어머니 쉬렌이여! 도와주소서!', // リンドビオル：ああっ！母なるシーレンよ！お助けください！
  1917: '%0 군주/부군주가 %1 님의 혈맹 탈퇴를 거부했습니다.', // %0君主/副君主が%1の血盟脱退を拒否しました。
  1925: '혈맹전 중에 탈퇴했으므로 %0 시간 동안은 혈맹에 가입할 수 없습니다.', // 血盟戦中に脱退したため、あと%0時間は血盟に加入できません。
  1973: '무기를 착용하면 사용할 수 있습니다.', // 武器を装着すると使用できます。
  1974: '생존의 외침은 아직 사용할 수 없습니다.', // 生存の叫びは、まだ使用できません。
  2068: '자신보다 낮은 등급만 변경할 수 있습니다.', // 自分より低いランクのみ変更できます。
  2123: '이미 보호 중인 아이템에는 쓸 수 없습니다.', // すでに保護中のアイテムには使用できません。
  2150: '등급을 바꿀 사람의 이름과 등급을 입력해 주세요. [등급 = 가디언, 일반, 수련]', // ランクを変更する人の名前とランクを入力してください。[ランク = ガーディアン、一般、修練]
  2471: '이 권한을 행사하려면 레벨 25 이상이어야 합니다.', // この権限を遂行するには、レベル25以上でなければなりません。
  2472: '이 권한을 행사하려면 레벨 40 이상이어야 합니다.', // この権限を遂行するには、レベル40以上でなければなりません。
  2478: '남은 시간이 30분 이내인 매직돌에만 충전할 수 있습니다.', // 残り30分以内のマジックドールにのみ、チャージが可能です。
  2739: '캐릭터가 혈맹에 가입되어 있습니다.', // キャラクターが血盟に加入しています。
  2788: '매직돌 사용 시간을 모두 써서 소환할 수 없습니다.', // キャラクター マジックドールの使用時間を使い切ったため、召還ができません。
  2921: '강철 길드 드워프: 음… 드래곤의 울음소리가 여기까지 들려온다. 분명 누군가 드래곤 포탈을 연 것이 틀림없다!', // 鋼鉄ギルド ドワーフ：うむ…ドラゴンの鳴き声がここまで聞こえてくる。きっと誰かがドラゴンポータルを開いたに違いない！
  2922: '강철 길드 드워프: 마법사 게렌 님이 방금 아덴 대륙에 드래곤 키가 나타났다고 하십니다.', // 鋼鉄ギルド ドワーフ：魔術師 ゲレン様が、たった今アデン大陸にドラゴンキーが現れたとおっしゃっています。
  3245: '당신을 기다리는 혈맹이 있습니다.', // あなたを待っている血盟があります。
  3246: '당신을 기다리는 혈맹원이 있습니다.', // あなたを待っている血盟員がいます。
  3247: '혈맹을 창설하고 간단히 알려 주세요.', // 血盟を創設して簡単にお知らせしてください。
  3248: '혈맹 가입 요청이 왔습니다!', // 血盟加入要請がきました！
  3260: '더 이상 혈맹원을 받을 수 없습니다.', // これ以上血盟員を受け入れることができません。
};

/**
 * 서버 메시지를 화면에 보여줄 문장으로 만든다.
 *
 * 표에 있으면 `%0`, `%1` … 자리에 인자를 채워 넣고, 없으면 인자만이라도
 * 보여준다. 인자마저 없으면 번호를 남긴다 — 무엇이 왔는지 추적할 수 있어야 한다.
 *
 * 인자에 들어 있는 `$1958 $1938` 같은 이름 ID까지 실제 이름으로 바꾸려면
 * `utils/nameResolver.ts`의 `formatServerMessage()`를 쓴다. 이 함수는 이름 표를
 * 끌어들이지 않는 순수 버전이다.
 */
export function formatServerMessage(messageId: number, args: string[] = []): string {
  const template = SERVER_MESSAGES[messageId];

  if (!template) {
    const joined = args.filter(Boolean).join(' ').trim();
    return joined || `서버 메시지 #${messageId}`;
  }

  return template.replace(/%(\d)/g, (_, i: string) => args[Number(i)] ?? '');
}
